<div class="configuration-wrapper">
  <form [formGroup]="configurationForm" class="configuration-container">
    <ion-row class="wrapper">
      <!-- Data Retention -->
      <ion-col size="auto" class="mr-24">
        <div class="medium-input-group">
          <app-form-text-field
            [labelText]="CONSTANTS.DATA_RETENTION"
            [maxLength]="2"
            [form]="configurationForm"
            [regexType]="SpecialCharacters.NUMBER_ONLY"
            [control]="'dataRetentionDays'"
            [hasRequiredSign]="false"
            [placeholderText]="CONSTANTS.RETENTION_PLACEHOLDER"
          ></app-form-text-field>
        </div>
      </ion-col>
      <!-- Location Type -->
      <ion-col size="auto">
        <div class="medium-input-group">
          <app-form-text-field
            [labelText]="CONSTANTS.LOCATION_TYPE"
            [maxLength]="2"
            [form]="configurationForm"
            [regexType]="SpecialCharacters.NUMBER_ONLY"
            [control]="'locationType'"
            [hasRequiredSign]="false"
            [placeholderText]="CONSTANTS.LOCATION_TYPE_PLACEHOLDER"
          ></app-form-text-field>
        </div>
      </ion-col>
    </ion-row>
    <!--Enablements-->
    <ion-grid class="wrapper">
      <ion-row>
        <h3 class="heading">{{ CONSTANTS.ENABLEMENTS }}</h3>
      </ion-row>
      <ion-row>
        <ion-col size="3">
          <app-form-checkbox
            [label]="CONSTANTS.MESSAGING"
            formControlName="messagingEnabled"
          ></app-form-checkbox>
        </ion-col>
        <ion-col size="3.5">
          <app-form-checkbox
            [label]="CONSTANTS.GIO"
            formControlName="gioEnabled"
          ></app-form-checkbox>
        </ion-col>
        <ion-col size="2.5">
          <app-form-checkbox
            [label]="CONSTANTS.INTERCEPTS"
            formControlName="interceptsActive"
          ></app-form-checkbox>
        </ion-col>
        <ion-col size="3">
          <app-form-checkbox
            [label]="CONSTANTS.BYOD"
            formControlName="byodEnabled"
          >
          </app-form-checkbox>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="3">
          <app-form-checkbox
            [label]="CONSTANTS.DRIVER_RELEASE"
            formControlName="driverReleaseEnabled"
          >
          </app-form-checkbox>
        </ion-col>
        <ion-col size="3.5">
          <app-form-checkbox
            [label]="CONSTANTS.SAFE_PLACE_PHOTO"
            formControlName="safePlacePhotoEnabled"
          >
          </app-form-checkbox>
        </ion-col>
        <ion-col size="2.5">
          <app-form-checkbox
            [label]="CONSTANTS.ADL"
            formControlName="adlActive"
          >
          </app-form-checkbox>
        </ion-col>
        <ion-col size="3">
          <app-form-checkbox
            [label]="CONSTANTS.HAZMAT"
            formControlName="hazmatEnabled"
          >
          </app-form-checkbox>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="3">
          <app-form-checkbox
            [label]="CONSTANTS.ON_DEMAND_PICKUPS"
            formControlName="onRoadPickupEnabled"
          >
          </app-form-checkbox>
        </ion-col>
        <ion-col size="3.5">
          <app-form-checkbox
            [label]="CONSTANTS.ODPU_PROVIDE_RECEIPT"
            formControlName="onCallPickupProvideReceipt"
          >
          </app-form-checkbox>
        </ion-col>
        <ion-col size="2.5">
          <app-form-checkbox
            [label]="CONSTANTS.FILE_UPLOAD"
            formControlName="fileUploadEnabled"
          >
          </app-form-checkbox>
        </ion-col>
        <ion-col size="3">
          <app-form-checkbox
            [label]="CONSTANTS.CENTER_SLIC"
            formControlName="centerSlicEnabled"
          >
          </app-form-checkbox>
        </ion-col>
      </ion-row>
    </ion-grid>
    <!--------------->
    <!--Visibility-->
    <ion-grid class="wrapper">
      <ion-row>
        <h3 class="heading">{{ CONSTANTS.VISIBILITY }}</h3>
      </ion-row>
      <ion-row>
        <ion-col size="3">
          <app-form-checkbox
            [label]="CONSTANTS.DRIVER_LOAD"
            formControlName="driverLoadVisibility"
          >
          </app-form-checkbox>
        </ion-col>
        <ion-col size="3.5">
          <app-form-checkbox
            [label]="CONSTANTS.HANDOVER"
            formControlName="handoverVisibility"
          >
          </app-form-checkbox>
        </ion-col>
        <ion-col size="5.5">
          <app-form-checkbox
            [label]="CONSTANTS.EDW_ETA"
            formControlName="edwEtaApiOnlyVisibility"
          >
          </app-form-checkbox>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="3">
          <app-form-checkbox
            [label]="CONSTANTS.GTSTIMECARD"
            formControlName="gtsTimeCardEnabled"
            (valueChanged)="onGtsTimeCardChange($event)"
          >
          </app-form-checkbox>
        </ion-col>
        @if (configurationForm.get("gtsTimeCardEnabled")?.value === true) {
          <ion-col>
            <ion-radio-group formControlName="gtsDriverSelected">
              <ion-row>
                <ion-col size="auto">
                  <ion-radio
                    class="radio-btn"
                    labelPlacement="end"
                    [value]="false"
                  >
                    {{ CONSTANTS.LOCATION }}
                  </ion-radio>
                </ion-col>
                <ion-col size="auto" push="1">
                  <ion-radio
                    class="radio-btn"
                    labelPlacement="end"
                    [value]="true"
                  >
                    {{ CONSTANTS.DRIVER }}
                  </ion-radio>
                </ion-col>
              </ion-row>
            </ion-radio-group>
          </ion-col>
        }
      </ion-row>
      @if (configurationForm.get("gtsTimeCardEnabled")?.value === true) {
        @if (!!configurationForm.get("gtsDriverSelected")?.value) {
          <ion-row>
            <!-- Sup Group -->
            <ion-col size="3">
              <app-form-text-field
                [labelText]="CONSTANTS.SUP_GROUP"
                [maxLength]="1"
                [form]="configurationForm"
                [regexType]="REGEX"
                [control]="'supGroupDriver'"
                [hasRequiredSign]="true"
                [placeholderText]="CONSTANTS.ENTER_SUB_GROUP"
                [autoCapitalizeCharacters]="true"
              ></app-form-text-field>
            </ion-col>
            <!-- Send Time -->
            <ion-col size="auto">
              <app-form-select
                [label]="CONSTANTS.SEND_TIME"
                [options]="timeRangeOptions"
                formControlName="sendDataDriverTime"
                [placeholder]="CONSTANTS.SEND_TIME_PLACEHOLDER"
              >
              </app-form-select>
            </ion-col>
          </ion-row>
        }
        @if (!configurationForm.get("gtsDriverSelected")?.value) {
          <ion-row class="pl-34">
            <!-- Contractor ID -->
            <ion-col size="3">
              <div>
                <app-form-text-field
                  [labelText]="CONSTANTS.CONTRACTOR_ID"
                  [maxLength]="11"
                  [form]="configurationForm"
                  [regexType]="SpecialCharacters.ALPHABET_NUMBER_NO_SPACE"
                  [control]="'contractorId'"
                  [hasRequiredSign]="true"
                  [placeholderText]="CONSTANTS.ENTER_ID"
                  [autoCapitalizeCharacters]="true"
                ></app-form-text-field>
              </div>
            </ion-col>
            <!-- Contractor Name -->
            <ion-col size="3">
              <div>
                <app-form-text-field
                  [labelText]="CONSTANTS.CONTRACTOR_NAME"
                  [maxLength]="12"
                  [form]="configurationForm"
                  [regexType]="SpecialCharacters.ALPHA_SPACE_ONLY"
                  [control]="'contractorName'"
                  [hasRequiredSign]="true"
                  [placeholderText]="CONSTANTS.ENTER_NAME"
                  [autoCapitalizeCharacters]="true"
                ></app-form-text-field>
              </div>
            </ion-col>
            <!-- Sup Group -->
            <ion-col size="3">
              <div>
                <app-form-text-field
                  [labelText]="CONSTANTS.SUP_GROUP"
                  [maxLength]="1"
                  [form]="configurationForm"
                  [regexType]="SpecialCharacters.ALPHABET_NUMBER_NO_SPACE"
                  [control]="'supGroupLocation'"
                  [hasRequiredSign]="true"
                  [placeholderText]="CONSTANTS.ENTER_SUB_GROUP"
                  [autoCapitalizeCharacters]="true"
                ></app-form-text-field>
              </div>
            </ion-col>
            <!-- Send time -->
            <ion-col size="auto">
              <div>
                <app-form-select
                  [label]="CONSTANTS.SEND_TIME"
                  [options]="timeRangeOptions"
                  formControlName="sendDataLocationTime"
                  [placeholder]="CONSTANTS.SEND_TIME_PLACEHOLDER"
                >
                </app-form-select>
              </div>
            </ion-col>
          </ion-row>
          <ion-row class="pl-34">
            <ion-col size="12" class="mb-10">
              <app-form-checkbox
                [label]="CONSTANTS.ADDITIONAL_TIMECARD_FEED"
                formControlName="additionalTimeCardFeed"
              ></app-form-checkbox>
            </ion-col>
            @if (
              configurationForm.get("additionalTimeCardFeed")?.value === true
            ) {
              <ion-col size="3">
                <div>
                  <app-form-text-field
                    [labelText]="CONSTANTS.CONTRACTOR_ID"
                    [maxLength]="11"
                    [form]="configurationForm"
                    [regexType]="SpecialCharacters.ALPHABET_NUMBER_NO_SPACE"
                    [control]="'additionalContractorId'"
                    [hasRequiredSign]="true"
                    [placeholderText]="CONSTANTS.ENTER_ID"
                    [autoCapitalizeCharacters]="true"
                  ></app-form-text-field>
                </div>
              </ion-col>
              <ion-col size="3">
                <div>
                  <app-form-text-field
                    [labelText]="CONSTANTS.CONTRACTOR_NAME"
                    [maxLength]="12"
                    [form]="configurationForm"
                    [regexType]="SpecialCharacters.ALPHA_SPACE_ONLY"
                    [control]="'additionalContractorName'"
                    [hasRequiredSign]="true"
                    [placeholderText]="CONSTANTS.ENTER_NAME"
                  ></app-form-text-field>
                </div>
              </ion-col>
              <ion-col size="3">
                <div>
                  <app-form-text-field
                    [labelText]="CONSTANTS.SUP_GROUP"
                    [maxLength]="1"
                    [form]="configurationForm"
                    [regexType]="SpecialCharacters.ALPHABET_NUMBER_NO_SPACE"
                    [control]="'additionalSupGroup'"
                    [hasRequiredSign]="true"
                    [placeholderText]="CONSTANTS.ENTER_SUB_GROUP"
                    [autoCapitalizeCharacters]="true"
                  ></app-form-text-field>
                </div>
              </ion-col>
              <ion-col size="auto">
                <div>
                  <app-form-select
                    [label]="CONSTANTS.SEND_TIME"
                    [options]="timeRangeOptions"
                    formControlName="additionalSendDataTime"
                    [placeholder]="CONSTANTS.SEND_TIME_PLACEHOLDER"
                  >
                  </app-form-select>
                </div>
              </ion-col>
            }
          </ion-row>
        }
      }
    </ion-grid>
    <!--------------->
    <!--IDO-->
    <ion-grid class="wrapper no-border">
      <ion-row>
        <h3 class="heading">{{ CONSTANTS.IDO }}</h3>
      </ion-row>
      <ion-row
        [ngClass]="{ 'mb-14': configurationForm.get('ido')?.value === true }"
      >
        <app-form-checkbox
          [label]="CONSTANTS.INTERNATIONAL_DISPATCH_OPTIMIZATION"
          formControlName="ido"
          (valueChanged)="onIdoChange($event)"
        ></app-form-checkbox>
      </ion-row>
      @if (configurationForm.get("ido")?.value === true) {
        <ion-row>
          <ion-col size="12" class="ion-no-padding">
            <ion-row class="wrapper pl-12">
              <!-- Latitude -->
              <ion-col size="auto">
                <div class="form-group large-input-group">
                  <app-form-text-field
                    [labelText]="CONSTANTS.LATITUDE"
                    [form]="configurationForm"
                    [control]="'latitude'"
                    [maxLength]="14"
                    [invalidPatternMessage]="CONSTANTS.INVALID_LATITUDE"
                    [requiredErrorMessage]="
                      CONSTANTS.LAT_LONG_REQUIRED.replace(
                        '%s',
                        CONSTANTS.LATITUDE
                      )
                    "
                  ></app-form-text-field>
                </div>
              </ion-col>
              <!-- Longitude -->
              <ion-col size="auto">
                <div class="form-group large-input-group ml-38">
                  <app-form-text-field
                    [labelText]="CONSTANTS.LONGITUDE"
                    [form]="configurationForm"
                    [control]="'longitude'"
                    [maxLength]="14"
                    [invalidPatternMessage]="CONSTANTS.INVALID_LONGITUDE"
                    [requiredErrorMessage]="
                      CONSTANTS.LAT_LONG_REQUIRED.replace(
                        '%s',
                        CONSTANTS.LONGITUDE
                      )
                    "
                  ></app-form-text-field>
                </div>
              </ion-col>
            </ion-row>
          </ion-col>
          <ion-col size="3">
            <app-form-select
              [label]="CONSTANTS.IDO_TYPE"
              [options]="idoTypeOptions"
              formControlName="idoType"
              [required]="isIDO"
              [placeholder]="CONSTANTS.SELECT"
            >
            </app-form-select>
          </ion-col>
          <ion-col size="3">
            <app-form-select
              [label]="CONSTANTS.LOCATION_START"
              [options]="locationStartOptions"
              formControlName="startEndLocation"
              [required]="isIDO"
              [placeholder]="CONSTANTS.SELECT"
            >
            </app-form-select>
          </ion-col>
          <ion-col size="3">
            <app-form-select
              [label]="CONSTANTS.BREAK_START"
              [options]="breakHourOptions"
              formControlName="breakStart"
              [required]="isIDO"
              [placeholder]="CONSTANTS.SELECT"
            >
            </app-form-select>
          </ion-col>
          <ion-col size="3">
            <app-form-select
              [label]="CONSTANTS.DEL_WAIT_TIME"
              [options]="waitTimeOptions"
              formControlName="waitTimeDelivery"
              [required]="isIDO"
              [placeholder]="CONSTANTS.SELECT"
            >
            </app-form-select>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="3">
            <app-form-select
              [label]="CONSTANTS.OPTIMIZE"
              [options]="optimizeOptions"
              formControlName="optimizationEnabled"
              [required]="isIDO"
              [placeholder]="CONSTANTS.SELECT"
            >
            </app-form-select>
          </ion-col>
          <ion-col size="3">
            <app-form-select
              [label]="CONSTANTS.LOCATION_END"
              [options]="locationEndOptions"
              formControlName="locationEnd"
              [required]="isIDO"
              [placeholder]="CONSTANTS.SELECT"
            >
            </app-form-select>
          </ion-col>
          <ion-col size="3">
            <app-form-select
              [label]="CONSTANTS.BREAK_END"
              [options]="breakHourEndOptions"
              formControlName="breakEnd"
              [required]="isIDO"
              [placeholder]="CONSTANTS.SELECT"
            >
            </app-form-select>
          </ion-col>
          <ion-col size="3">
            <app-form-select
              [label]="CONSTANTS.PU_WAIT_TIME"
              [options]="puWaitTimeOptions"
              formControlName="waitTimePickup"
              [required]="isIDO"
              [placeholder]="CONSTANTS.SELECT"
            >
            </app-form-select>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="3">
            <app-form-select
              [label]="CONSTANTS.VEHICLE"
              [options]="vehicleOptions"
              formControlName="vehicleType"
              [required]="isIDO"
              [placeholder]="CONSTANTS.SELECT"
            >
            </app-form-select>
          </ion-col>
          <ion-col size="3">
            <app-form-select
              [label]="CONSTANTS.LEAVE_BLDG_TIME"
              [options]="leaveBldgOptions"
              formControlName="leaveBuildingTime"
              [required]="isIDO"
              [placeholder]="CONSTANTS.SELECT"
            >
            </app-form-select>
          </ion-col>
          <ion-col size="3">
            <app-form-text-field
              [labelText]="CONSTANTS.BREAK_DURATION"
              [maxLength]="3"
              [form]="configurationForm"
              [regexType]="REGEX"
              [control]="'breakDuration'"
              [placeholderText]="'1 - 119'"
            ></app-form-text-field>
          </ion-col>
          <ion-col size="3">
            <app-form-select
              [label]="CONSTANTS.DISTANCE_UNITS"
              [options]="distanceUnitOptions"
              formControlName="distanceUnits"
              [required]="isIDO"
              [placeholder]="CONSTANTS.SELECT"
            >
            </app-form-select>
          </ion-col>
        </ion-row>
        <!--Checkbox Row-->
        <ion-row>
          <ion-col size="3">
            <app-form-checkbox
              [label]="CONSTANTS.EDW"
              formControlName="edwEnabled"
            ></app-form-checkbox>
          </ion-col>
          <ion-col size="3">
            <app-form-checkbox
              [label]="CONSTANTS.FMD"
              formControlName="followMyDeliveryEnabled"
            ></app-form-checkbox>
          </ion-col>
          <ion-col size="3">
            <app-form-checkbox
              [label]="CONSTANTS.ITINERARY_REORDERING"
              formControlName="itineraryReordering"
            ></app-form-checkbox>
          </ion-col>
          <ion-col size="3">
            <app-form-checkbox
              [label]="CONSTANTS.FORECAST_SMART_SCAN"
              formControlName="forecastSmartScanEnabled"
            ></app-form-checkbox>
          </ion-col>
        </ion-row>
        <!---------------->
        <!--Trimble Dispatch Row-->
        <ion-row>
          <ion-col size="3">
            <app-form-checkbox
              [label]="CONSTANTS.TRIMBLE_DISPATCH"
              formControlName="trimbleDispatchPlanning"
            ></app-form-checkbox>
          </ion-col>
        </ion-row>
        <!------------------------>
      }
    </ion-grid>
    <!--------------->
  </form>

  <!-- footer -->
  <div class="configuration-footer">
    <app-footer-action-bar
      [form]="configurationForm"
      [edit]="edit"
      [btnText]="'Save'"
      [btnEnabled]="
        edit
          ? configurationForm.valid && idoComplete && formDirty
          : configurationForm.valid && idoComplete
      "
      [resetBtnEnabled]="formDirty"
      (submitBtnClick)="submitLocationProfile()"
      (resetBtnClick)="resetConfigForm()"
    ></app-footer-action-bar>
  </div>
</div>
